import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@porchpass/ui";
import { ChevronDown, Plus } from "lucide-react";
import type {
  ConditionSection,
  PreApprovalNote,
} from "src/api/preApproval/types";
import { formatDate } from "../../utils";

const PROMOTE_SECTIONS: { value: ConditionSection; label: string }[] = [
  { value: "customer", label: "Customer Conditions" },
  { value: "funding", label: "Funding Conditions" },
  { value: "seller", label: "Seller Conditions" },
];

interface NoteCardProps {
  note: PreApprovalNote;
  onEdit: () => void;
  onPromote: (section: ConditionSection) => void;
}

export function NoteCard({ note, onEdit, onPromote }: NoteCardProps) {
  return (
    <div className="rounded-xl border border-[#E4E7EC] bg-white p-3.5 flex flex-col gap-3">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1.5">
          <p className="font-medium text-[#101827]">{note.author}</p>
          <span className="text-xs text-[#9AA2B2]">
            {formatDate(note.created_at)}
          </span>
        </div>
        <p className="text-sm text-[#697083] whitespace-pre-wrap">
          {note.note}
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <Button type="button" variant="secondary" size="s" onClick={onEdit}>
          Edit
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button type="button" variant="secondary" size="s">
              <Plus className="h-3.5 w-3.5" />
              Add to Pre-Approval Conditions
              <ChevronDown className="h-3.5 w-3.5" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            {PROMOTE_SECTIONS.map((section) => (
              <DropdownMenuItem
                key={section.value}
                onClick={() => onPromote(section.value)}
              >
                {section.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
